import { PLACEHOLDER } from "./site";

export const PROGRAMS = [
  {
    slug: { id: "program-manajemen-stres", en: "stress-management-program" },
    name: { id: "Program Manajemen Stres & Burnout", en: "Stress & Burnout Management Program" },
    problem: {
      id: "Stres berkepanjangan dan kelelahan yang tidak membaik dengan istirahat.",
      en: "Prolonged stress and exhaustion that does not improve with rest.",
    },
    for: {
      id: "Profesional, orang tua, dan individu yang menghadapi tekanan berkelanjutan.",
      en: "Professionals, parents and individuals facing ongoing pressure.",
    },
    goals: {
      id: ["Memahami sumber dan pola stres pribadi", "Membangun strategi pengelolaan yang efektif", "Memulihkan energi dan keseimbangan"],
      en: ["Understand personal stress sources and patterns", "Build effective management strategies", "Restore energy and balance"],
    },
  },
  {
    slug: { id: "program-pendampingan-anak-remaja", en: "child-adolescent-support-program" },
    name: { id: "Program Pendampingan Anak & Remaja", en: "Child & Adolescent Support Program" },
    problem: {
      id: "Kekhawatiran emosi, perilaku, atau perkembangan pada anak dan remaja.",
      en: "Emotional, behavioral or developmental concerns in children and teenagers.",
    },
    for: {
      id: "Anak, remaja, dan orang tua yang membutuhkan pendampingan terstruktur.",
      en: "Children, adolescents and parents who need structured support.",
    },
    goals: {
      id: ["Memahami kebutuhan perkembangan anak", "Mendukung regulasi emosi dan perilaku", "Membekali orang tua dengan strategi pengasuhan"],
      en: ["Understand the child's developmental needs", "Support emotional and behavioral regulation", "Equip parents with parenting strategies"],
    },
  },
  {
    slug: { id: "program-pengembangan-diri", en: "personal-development-program" },
    name: { id: "Program Pengembangan Diri", en: "Personal Development Program" },
    problem: {
      id: "Keinginan bertumbuh secara pribadi dengan arah yang lebih jelas dan terukur.",
      en: "A desire to grow personally with clearer, measurable direction.",
    },
    for: {
      id: "Individu yang ingin memahami diri, membangun kepercayaan diri, dan mencapai tujuan pribadi.",
      en: "Individuals wanting to understand themselves, build confidence and reach personal goals.",
    },
    goals: {
      id: ["Pemetaan kekuatan dan area pengembangan", "Membangun pola pikir dan kebiasaan yang mendukung", "Rencana pengembangan yang terukur"],
      en: ["Map strengths and development areas", "Build supportive mindsets and habits", "A measurable development plan"],
    },
  },
];

export const programCommon = {
  structure: { id: PLACEHOLDER.id, en: PLACEHOLDER.en },
  format: { id: PLACEHOLDER.id, en: PLACEHOLDER.en },
  duration: { id: PLACEHOLDER.id, en: PLACEHOLDER.en },
  price: {
    id: "Informasi biaya dapat ditanyakan melalui WhatsApp. [Akan dilengkapi oleh tim Bali Empower]",
    en: "Fee information is available via WhatsApp. [To be confirmed by the Bali Empower team]",
  },
  professional: {
    id: "Program didampingi tenaga profesional psikologi Bali Empower. [Profil akan dilengkapi]",
    en: "Programs are guided by Bali Empower psychology professionals. [Profiles to be completed]",
  },
  note: {
    id: "Setiap program diawali konsultasi untuk memastikan kesesuaian dengan kebutuhan Anda. Struktur detail program akan dilengkapi oleh tim Bali Empower.",
    en: "Every program begins with a consultation to ensure it fits your needs. Detailed program structure will be completed by the Bali Empower team.",
  },
};

export const findProgram = (lang, slug) =>
  PROGRAMS.find((p) => p.slug[lang] === slug);
